var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrofeoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-00fc7293-7074-4987-9ac1-7dc8e25c5295",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1080 983.02",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "uuid-1ed54813-5653-46dc-a4ab-89c6e6a53c95",
    d: "M1078.3,196.44c-10.46-93.52-113.91-116.89-190.82-116.08v-36.74c0-24.05-19.97-43.61-44.52-43.61H237.05c-24.52,0-44.5,19.56-44.5,43.61v36.64C115.62,79.26,12.18,102.86,1.7,196.44c-8.94,79.89,17.12,193.8,84.23,256.82,30.88,29.04,67.85,44.13,108.09,45.09,14.01,165.52,149.29,297.55,318.43,310.66v120.02h-174.59c-15.24,0-27.56,12.08-27.56,27s12.33,27,27.56,27h404.29c15.24,0,27.56-12.08,27.56-27s-12.33-27-27.56-27h-174.57v-120.02c169.14-13.1,304.42-145.14,318.43-310.66,40.24-.96,77.22-16.04,108.12-45.09,67.08-63.07,93.11-176.92,84.17-256.82ZM124.07,414.28c-51.68-48.57-74.94-145.92-67.57-211.94,6.75-60.24,92.61-67.7,136.05-67.62v309.63c-25.38-1.31-48.44-11.25-68.48-30.07ZM832.35,470.02c0,157.89-131.15,286.35-292.33,286.35s-292.33-128.46-292.33-286.35V54h584.67v416.02ZM887.48,444.35V134.74c43.43-.07,129.29,7.38,136.02,67.61,7.4,66.02-15.83,163.37-67.54,211.94-20.03,18.83-43.07,28.77-68.48,30.07Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrofeoIcon);
export default __webpack_public_path__ + "static/media/TrofeoIcon.0bd405b06c2edd72d8057c371e255d8d.svg";
export { ForwardRef as ReactComponent };